/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { lazy, Suspense } from "react";
import {
  Route,
  Switch,
  Redirect,
  BrowserRouter,
  HashRouter,
  useHistory,
} from "react-router-dom";

import ScrollToTop from "./ScrollToTop";
import { routes } from "../services/appNavigatorService/config/routes.config.json";

import { lazyWithRetry } from "./ComponentLoader";
import { RouteWithSidebar } from "@vlinder-web/route-with-sidebar-widget-react";
import { PrivateRoute } from "@vlinder-web/private-route-widget-react";
import { StorageModule } from "@vlinder-web/storage-module-react";
import { StateOSD } from "@vlinder-web/state-osd-v2-widget-react";
import { VApplication } from "../application";
import { AppNavigatorService } from "../services";
import { useSMAppNavigator } from "./machines/pageContent";

//NOTE: Don't do lazy binding for landing page from v2 widget
import LandingPage from "../pages/Landing";
import toast from "react-hot-toast";
import { DEFAULT_APP_CONFIG } from "../config/default.config";

//Privacy and Terms Pages

const TermsPage = lazyWithRetry(() => import("../pages/Terms"));
const PrivacyPage = lazyWithRetry(() => import("../pages/Privacy"));
const RolesPage = lazyWithRetry(() => import("../pages/Roles"));
const FAQPage = lazyWithRetry(() => import("../pages/FaqPage"));

const ProductLandingPage = lazyWithRetry(
  () => import("../pages/ProductLandingPage")
);
const FHPPolicyPage = lazyWithRetry(() => import("../pages/FHPPolicy"));
//sidebar Pages
const ProvisionalPoliciesPage = lazyWithRetry(
  () => import("../pages/ProvisionalPage")
);
const ActualPoliciesPage = lazyWithRetry(
  () => import("../pages/ActualPolicies")
);
const MyPoliciesDetailPage = lazyWithRetry(
  () => import("../pages/MyPolicydetail")
);
const MyAccountpage = lazyWithRetry(() => import("../pages/MyAccount"));
const UserListPage = lazyWithRetry(() => import("../pages/UsersList"));
const SignInPage = lazyWithRetry(() => import("../pages/SignIn"));
const MyPayoutPage = lazyWithRetry(() => import("../pages/PayoutDetailPage"));
const WeatherAnalytics = lazyWithRetry(
  () => import("../pages/WeatherAnalytics")
);
const AnalyticsAPIDetailPage = lazyWithRetry(
  () => import("../pages/AnalyticsAPIDetail")
);
const ArchivedPolicyPage = lazyWithRetry(() => import("../pages/ArchivedPolicyPage"));

const getAppNavService = () => {
  const app = VApplication.getInstance();
  return app?.getSync("services.AppNavigatorService") as AppNavigatorService;
};

const RouterConfig = () => {
  const { appNavigatorSend, appNavigatorState, appNavigatorMachine } =
    useSMAppNavigator({});
  const appNavSrv = getAppNavService();
  const history = useHistory();

  const _handleDropDownItemClick = (item: any) => {
    const storageSrv = StorageModule?.getInstance();

    console.log("on DD Item click =>", item);
    if (item.id === "logout") {
      storageSrv.reset("session");
      storageSrv.reset("local");
      window.open(`/product/fhp`, "_self");
    } else if (item.id === "myProfile") {
      history.push(routes?.MyAccount?.path);
    } else {
      toast.success("Coming soon!");
    }
  };

  if (appNavigatorState?.matches("RENDER_PAGE")) {
    const {
      brandLogo,
      brandLogoLink,
      brandTitle,
      sidebarItems,
      routes,
      orgName,
      orgUrl,
      copyrightStartYear,
      whoami,
      userName,
      userImage,
      dropdownItems,
      footerSection,
    } = { ...(appNavigatorState?.event?.data?.value || {}) };
    return (
      <Switch>
        <RouteWithSidebar
          exact
          path={routes?.ProvisionalPolicies?.path}
          component={ProvisionalPoliciesPage}
          brandLogo={brandLogo}
          brandLogoLink={brandLogoLink}
          brandTitle={brandTitle}
          items={sidebarItems}
          notFoundLink={routes?.NotFound?.path}
          abilityCheck={appNavSrv?.abilityCheck.bind(
            null,
            routes?.ProvisionalPolicies?.id,
            whoami,
            "read"
          )}
          userName={userName}
          userImage={userImage}
          dropDownItems={dropdownItems}
          onDropDownItemClick={_handleDropDownItemClick}
          orgName={orgName}
          orgUrl={orgUrl}
          copyrightStartYear={copyrightStartYear}
          footerSections={footerSection}

          // sidebarStyle={{ backgroundColor: "#113DA0" }}
        />
        <RouteWithSidebar
          exact
          path={routes?.Archived?.path}
          component={ArchivedPolicyPage}
          brandLogo={brandLogo}
          brandLogoLink={brandLogoLink}
          brandTitle={brandTitle}
          items={sidebarItems}
          notFoundLink={routes?.NotFound?.path}
          abilityCheck={appNavSrv?.abilityCheck.bind(
            null,
            routes?.Archived?.id,
            whoami,
            "read"
          )}
          userName={userName}
          userImage={userImage}
          dropDownItems={dropdownItems}
          onDropDownItemClick={_handleDropDownItemClick}
          orgName={orgName}
          orgUrl={orgUrl}
          copyrightStartYear={copyrightStartYear}
          footerSections={footerSection}

          // sidebarStyle={{ backgroundColor: "#113DA0" }}
        />
        <RouteWithSidebar
          exact
          path={routes?.ActualPolicies?.path}
          component={ActualPoliciesPage}
          brandLogo={brandLogo}
          brandLogoLink={brandLogoLink}
          brandTitle={brandTitle}
          items={sidebarItems}
          notFoundLink={routes?.NotFound?.path}
          abilityCheck={appNavSrv?.abilityCheck.bind(
            null,
            routes?.ActualPolicies?.id,
            whoami,
            "read"
          )}
          userName={userName}
          userImage={userImage}
          dropDownItems={dropdownItems}
          onDropDownItemClick={_handleDropDownItemClick}
          orgName={orgName}
          orgUrl={orgUrl}
          copyrightStartYear={copyrightStartYear}
          footerSections={footerSection}
          // sidebarStyle={{ backgroundColor: "#113DA0" }}
        />
        <RouteWithSidebar
          exact
          path={routes?.ActualPolicyDetail?.path}
          component={MyPoliciesDetailPage}
          brandLogo={brandLogo}
          brandLogoLink={brandLogoLink}
          brandTitle={brandTitle}
          items={sidebarItems}
          notFoundLink={routes?.NotFound?.path}
          abilityCheck={appNavSrv?.abilityCheck.bind(
            null,
            routes?.ActualPolicyDetail?.id,
            whoami,
            "read"
          )}
          userName={userName}
          userImage={userImage}
          dropDownItems={dropdownItems}
          onDropDownItemClick={_handleDropDownItemClick}
          orgName={orgName}
          orgUrl={orgUrl}
          copyrightStartYear={copyrightStartYear}
          footerSections={footerSection}
          // sidebarStyle={{ backgroundColor: "#113DA0" }}
        />
        <RouteWithSidebar
          exact
          path={routes?.ProvisionalPolicyDetail?.path}
          component={MyPoliciesDetailPage}
          brandLogo={brandLogo}
          brandLogoLink={brandLogoLink}
          brandTitle={brandTitle}
          items={sidebarItems}
          notFoundLink={routes?.NotFound?.path}
          abilityCheck={appNavSrv?.abilityCheck.bind(
            null,
            routes?.ProvisionalPolicyDetail?.id,
            whoami,
            "read"
          )}
          userName={userName}
          userImage={userImage}
          dropDownItems={dropdownItems}
          onDropDownItemClick={_handleDropDownItemClick}
          orgName={orgName}
          orgUrl={orgUrl}
          copyrightStartYear={copyrightStartYear}
          footerSections={footerSection}
          // sidebarStyle={{ backgroundColor: "#113DA0" }}
        />
        <RouteWithSidebar
          exact
          path={routes?.ArchivedPolicyDetail?.path}
          component={MyPoliciesDetailPage}
          brandLogo={brandLogo}
          brandLogoLink={brandLogoLink}
          brandTitle={brandTitle}
          items={sidebarItems}
          notFoundLink={routes?.NotFound?.path}
          abilityCheck={appNavSrv?.abilityCheck.bind(
            null,
            routes?.ArchivedPolicyDetail?.id,
            whoami,
            "read"
          )}
          userName={userName}
          userImage={userImage}
          dropDownItems={dropdownItems}
          onDropDownItemClick={_handleDropDownItemClick}
          orgName={orgName}
          orgUrl={orgUrl}
          copyrightStartYear={copyrightStartYear}
          footerSections={footerSection}
          // sidebarStyle={{ backgroundColor: "#113DA0" }}
        />
        <RouteWithSidebar
          exact
          path={routes?.MyAccount?.path}
          component={MyAccountpage}
          brandLogo={brandLogo}
          brandLogoLink={brandLogoLink}
          brandTitle={brandTitle}
          items={sidebarItems}
          notFoundLink={routes?.NotFound?.path}
          abilityCheck={appNavSrv?.abilityCheck.bind(
            null,
            routes?.MyAccount?.id,
            whoami,
            "read"
          )}
          userName={userName}
          userImage={userImage}
          dropDownItems={dropdownItems}
          onDropDownItemClick={_handleDropDownItemClick}
          orgName={orgName}
          orgUrl={orgUrl}
          copyrightStartYear={copyrightStartYear}
          footerSections={footerSection}
          // sidebarStyle={{ backgroundColor: "#113DA0" }}
        />
        <RouteWithSidebar
          exact
          path={routes?.WeatherAnalytics?.path}
          component={WeatherAnalytics}
          brandLogo={brandLogo}
          brandLogoLink={brandLogoLink}
          brandTitle={brandTitle}
          items={sidebarItems}
          notFoundLink={routes?.NotFound?.path}
          abilityCheck={appNavSrv?.abilityCheck.bind(
            null,
            routes?.WeatherAnalytics?.id,
            whoami,
            "read"
          )}
          userName={userName}
          userImage={userImage}
          dropDownItems={dropdownItems}
          onDropDownItemClick={_handleDropDownItemClick}
          orgName={orgName}
          orgUrl={orgUrl}
          copyrightStartYear={copyrightStartYear}
          footerSections={footerSection}
          // sidebarStyle={{ backgroundColor: "#113DA0" }}
        />
        <RouteWithSidebar
          exact
          path={routes?.AnalyticsAPIDetail?.path}
          component={AnalyticsAPIDetailPage}
          brandLogo={brandLogo}
          brandLogoLink={brandLogoLink}
          brandTitle={brandTitle}
          items={sidebarItems}
          notFoundLink={routes?.NotFound?.path}
          abilityCheck={appNavSrv?.abilityCheck.bind(
            null,
            routes?.AnalyticsAPIDetail?.id,
            whoami,
            "read"
          )}
          userName={userName}
          userImage={userImage}
          dropDownItems={dropdownItems}
          onDropDownItemClick={_handleDropDownItemClick}
          orgName={orgName}
          orgUrl={orgUrl}
          copyrightStartYear={copyrightStartYear}
          footerSections={footerSection}
          // sidebarStyle={{ backgroundColor: "#113DA0" }}
        />
        <RouteWithSidebar
          exact
          path={routes?.PayoutKYC?.path}
          component={MyPayoutPage}
          brandLogo={brandLogo}
          brandLogoLink={brandLogoLink}
          brandTitle={brandTitle}
          items={sidebarItems}
          notFoundLink={routes?.NotFound?.path}
          abilityCheck={appNavSrv?.abilityCheck.bind(
            null,
            routes?.PayoutKYC?.id,
            whoami,
            "read"
          )}
          userName={userName}
          userImage={userImage}
          dropDownItems={dropdownItems}
          onDropDownItemClick={_handleDropDownItemClick}
          orgName={orgName}
          orgUrl={orgUrl}
          copyrightStartYear={copyrightStartYear}
          footerSections={footerSection}
          // sidebarStyle={{ backgroundColor: "#113DA0" }}
        />
        {/* <Route
          exact
          path={routes?.MyPolicy?.path}
          component={MyPolicyPage}
        /> */}
        <Route exact path="/" component={LandingPage} />
        <Route
          exact
          path={routes?.ProductLanding?.path}
          component={ProductLandingPage}
        />
        <Route exact path={routes?.SignIn?.path} component={SignInPage} />
        <Route
          exact
          path={routes?.PurchaseFlow?.path}
          component={FHPPolicyPage}
        />
        <Route exact path={routes?.Privacy?.path} component={PrivacyPage} />
        <Route exact path={routes?.Terms?.path} component={TermsPage} />
        <Route exact path={routes?.FAQPage?.path} component={FAQPage} />
        <Redirect to={routes?.NotFound?.path} />
      </Switch>
    );
  }
  if (appNavigatorState?.matches("GET_PAGE_CONTENT")) {
    return <StateOSD {...(DEFAULT_APP_CONFIG?.defaultLoading || {})} />;
  }
  return null;
};

export const AppNavigator = (): JSX.Element => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Suspense
        fallback={<StateOSD {...(DEFAULT_APP_CONFIG?.defaultLoading || {})} />}
      >
        <RouterConfig />
      </Suspense>
    </BrowserRouter>
  );
};
